// Mount Kidd RV Park booking strategy.
//
// Booking URL: passthrough of `site.reserveUrl` (same as default).
// Preview URL: the operator maintains a static site-map page outside
// the reservation system, so the request form's "View map" button
// points there instead of at the reserve URL.

import defaultStrategy from "./default.js";

const STATIC_MAP_URL = "https://www.mountkiddrv.com/index.php/sites";

export default {
  buildBookingUrl(ctx) {
    return defaultStrategy.buildBookingUrl(ctx);
  },

  buildPreviewUrl() {
    return STATIC_MAP_URL;
  },

  describeBookingInputs() {
    return defaultStrategy.describeBookingInputs();
  },
};
